import request from '@/utils/request'

var api = {
  //扫码签名
  wxSign(data){
    return request({
      url: 'web/User/wxSign',
      method: 'get',
      params:data
    })
  },
  //确认收衣
  getOrder(data){
    return request({
      url: 'web/User/getOrder',
      method: 'get',
      params: data
    })
  },
  subbitQrcode(data){
    return request({
      url: 'web/User/subbitQrcode',
      method: 'post',
      data: data
    })
  },
  loginStation(data){
    return request({
      url: 'web/Account/loginStation',
      method: 'post',
      data: data
    })
  },
  login(data){
    return request({
      url: 'web/Account/login',
      method: 'post',
      data: data
    })
  },
  out(data){
    return request({
      url: 'web/User/out',
      method: 'post',
      data: data
    })
  },
  password(data){
    return request({
      url: 'web/User/password',
      method: 'post',
      data: data
    })
  },
  checkCid(data){
    return request({
      url: 'web/User/checkCid',
      method: 'get',
      params: data
    })
  },
  getInfo(data){
    return request({
      url: 'web/User/info',
      method: 'get',
      params: data
    })
  },
  orderList(data){
    return request({
      url: 'web/User/orderList',
      method: 'get',
      params: data
    })
  },
  orderDetial(data){
    return request({
      url: 'web/User/orderDetial',
      method: 'get',
      params: data
    })
  },
  bindBalanceMsg(data){
    return request({
      url: 'web/User/bindBalanceMsg',
      method: 'post',
      data: data
    })
  },
}
export default api;


// WEBPACK FOOTER //
// ./src/utils/api.js